// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  width: 500px;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  font-family: sans-serif;
  direction: rtl;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 15px;
}


/* === Dropzone اصلی === */
.upload-dropzone {
  border: 2px dashed #EA6C22;
  border-radius: 12px;
  padding: 30px 20px;
  text-align: center;
  color: #666;
  margin-top: 10px;
}

/* === آیکن بالای متن === */
.upload-icon {
  font-size: 40px;
  display: block;
  margin-bottom: 10px;
}

/* === متن فرمت‌های مجاز === */
.upload-hint {
  display: block;         /* خط جداگانه */
  margin-top: 5px;        /* فاصله کم از متن قبلی */
  margin-bottom: 10px;    /* فاصله قبل از دکمه */

}

/* === دکمه انتخاب فایل === */
.file-btn {
  display: inline-block;
  background: #ea6c22;
  color: white;
  padding: 8px 18px;
  border-radius: 8px;
  cursor: pointer;
}


.preview-table {
  margin-top: 15px;
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 6px;
}

.preview-table table {
  width: 100%;
  border-collapse: collapse;
}

.preview-table td {
  border: 1px solid #ddd;
  padding: 4px 6px;
  font-size: 13px;
}

.hint {
  margin: 15px 0;
  font-size: 13px;
  color: #444;
}

.checkbox-row {
  display: flex;
  align-items: center;
  font-size: 13px;
  margin-bottom: 15px;
}

.checkbox-row input {
  margin-left: 8px;
}

.checkbox-row a {
  color: #ea6c22;
  text-decoration: none;
}

.modal-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sample-btn {
  border: 1px solid #ea6c22;
  color: #ea6c22;
  padding: 6px 14px;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
}

.action-buttons {
  display: flex;
  gap: 10px;
}

.primary-btn {
  background: #ea6c22;
  color: white;
  border: none;
  padding: 8px 18px;
  border-radius: 8px;
  cursor: pointer;
}

.cancel-btn {
  background: #eee;
  color: #444;
  border: none;
  padding: 8px 18px;
  border-radius: 8px;
  cursor: pointer;
}




.modal-close {
    position: absolute;
    top: 12px;
    right: 12px;
    background: #ff5f57;
    border: none;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    font-size: 18px;
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s, transform 0.2s;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.modal-close:hover {
    background: #ff3b30;
    transform: scale(1.1);
}

.modal-close:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(255, 91, 87, 0.4);
}





.failed-products-table {
  width: 100%;
  border-collapse: collapse;
}

.failed-products-table th,
.failed-products-table td {
  border: 1px solid black;
  padding: 8px;
  text-align: center;
}
.failed-products-table tbody td:last-child {
  font-weight: 600;
  color: #d32f2f;
}`, "",{"version":3,"sources":["webpack://./src/components/VisitorBulkUpload/ProductBulkUpload.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;AACrB;;;AAGA,0BAA0B;AAC1B;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,cAAc,UAAU,eAAe;EACvC,eAAe,SAAS,yBAAyB;EACjD,mBAAmB,KAAK,sBAAsB;;AAEhD;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;;;;AAKA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2CAA2C;IAC3C,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,4CAA4C;AAChD;;;;;;AAMA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: #fff;\n  width: 500px;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n  font-family: sans-serif;\n  direction: rtl;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 10px;\n  margin-bottom: 15px;\n}\n\n\n/* === Dropzone اصلی === */\n.upload-dropzone {\n  border: 2px dashed #EA6C22;\n  border-radius: 12px;\n  padding: 30px 20px;\n  text-align: center;\n  color: #666;\n  margin-top: 10px;\n}\n\n/* === آیکن بالای متن === */\n.upload-icon {\n  font-size: 40px;\n  display: block;\n  margin-bottom: 10px;\n}\n\n/* === متن فرمت‌های مجاز === */\n.upload-hint {\n  display: block;         /* خط جداگانه */\n  margin-top: 5px;        /* فاصله کم از متن قبلی */\n  margin-bottom: 10px;    /* فاصله قبل از دکمه */\n\n}\n\n/* === دکمه انتخاب فایل === */\n.file-btn {\n  display: inline-block;\n  background: #ea6c22;\n  color: white;\n  padding: 8px 18px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n\n.preview-table {\n  margin-top: 15px;\n  max-height: 150px;\n  overflow-y: auto;\n  border: 1px solid #eee;\n  border-radius: 6px;\n}\n\n.preview-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.preview-table td {\n  border: 1px solid #ddd;\n  padding: 4px 6px;\n  font-size: 13px;\n}\n\n.hint {\n  margin: 15px 0;\n  font-size: 13px;\n  color: #444;\n}\n\n.checkbox-row {\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n  margin-bottom: 15px;\n}\n\n.checkbox-row input {\n  margin-left: 8px;\n}\n\n.checkbox-row a {\n  color: #ea6c22;\n  text-decoration: none;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.sample-btn {\n  border: 1px solid #ea6c22;\n  color: #ea6c22;\n  padding: 6px 14px;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.primary-btn {\n  background: #ea6c22;\n  color: white;\n  border: none;\n  padding: 8px 18px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.cancel-btn {\n  background: #eee;\n  color: #444;\n  border: none;\n  padding: 8px 18px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n\n\n\n.modal-close {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    background: #ff5f57;\n    border: none;\n    border-radius: 50%;\n    width: 32px;\n    height: 32px;\n    font-size: 18px;\n    color: white;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.2s, transform 0.2s;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n}\n\n.modal-close:hover {\n    background: #ff3b30;\n    transform: scale(1.1);\n}\n\n.modal-close:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(255, 91, 87, 0.4);\n}\n\n\n\n\n\n.failed-products-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.failed-products-table th,\n.failed-products-table td {\n  border: 1px solid black;\n  padding: 8px;\n  text-align: center;\n}\n.failed-products-table tbody td:last-child {\n  font-weight: 600;\n  color: #d32f2f;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
